import React from 'react';
import { reject } from 'lodash/fp';
import * as Element from 'components/editor/element';
import { createAdder } from './adder';

const renderElement = elementData => {
  const { type, id } = elementData;
  const elementkey = `element_${id}`;

  switch (type.toLowerCase()) {
    case 'question':
    case 'screen_recording':
    case 'webcam_recording':
      return <Element.Question {...elementData} key={elementkey} />;
    case 'question_bank':
      return <Element.QuestionBank {...elementData} key={elementkey} />;
    case 'paragraph':
      return <Element.Paragraph {...elementData} key={elementkey} />;
    case 'document':
      return <Element.Document {...elementData} key={elementkey} />;
    case 'embed':
      return <Element.Embed {...elementData} key={elementkey} />;
    case 'flipcard':
      return <Element.Flipcard {...elementData} key={elementkey} />;
    case 'reveal':
      return <Element.Reveal {...elementData} key={elementkey} />;
    case 'lesson_content_image':
      return <Element.Image {...elementData} key={elementkey} />;
    case 'media_recording':
      return <Element.MediaRecording {...elementData} key={elementkey} />;
    case 'role_play':
      return <Element.RolePlay {...elementData} key={elementkey} />;
    case 'gong_call':
      return <Element.GongCall {...elementData} key={elementkey} />;
    case 'scorm':
      return <Element.Elearning {...elementData} key={elementkey} />;
    default:
      return false;
  }
};

const renderElements = ({ elements, isScormSection }) => {
  const list = [];
  const lastPosition = elements[elements.length - 1]?.position ?? 0;
  // elearning scorm will only have one element on the section and will not be able to add elements
  if (isScormSection) {
    list.push(renderElement(elements[0]));
  } else {
    elements.forEach((element, i) => {
      list.push(createAdder(element.position), renderElement(element));
    });
    list.push(createAdder(lastPosition + 1));
  }
  return list;
};

const SectionContentElements = ({ section }) => {
  return (
    <div className="Editor-elements" key={section.id}>
      {renderElements({
        elements: reject('parent_id', section.elements),
        isScormSection: section.is_scorm_section,
      })}
    </div>
  );
};

export default SectionContentElements;
